import addGame from "./addGame.ts";
import iterate from "./iterate.ts";

export default {
	addGame,
	iterate,
};
